(function () {
  'use strict';

  angular
    .module('multipleFlightsInRollingSevenDays')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('multipleFlightsInRollingSevenDays', {
        url: '/multiple-flights-in-rolling-seven-days',
        views: {
          'multipleFlightsInRollingSevenDaysView': {
            templateUrl: 'multiple-flights-in-rolling-seven-days/views/multiple-flights-in-rolling-seven-days.tpl.html',
            controller: 'multipleFlightsInRollingSevenDaysCtrl',
            controllerAs: 'multipleFlightsInRollingSevenDays'
          }
        }
      });
  }
}());
